import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Mic } from 'lucide-react';
import useDoExerciseStore from '../../store/exerciseStore';

const SpeechToText = ({question_id}) => {
  const [text, setText] = useState('');
  const [isListening, setIsListening] = useState(false);
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const {  addAnswer} = useDoExerciseStore()
  const handleAnswer = (answer) => {
    addAnswer({
      answer,
      question_id: question_id
    })
  }


  const startListening = () => {
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onstart = () => setIsListening(true);
    recognition.onend = () => setIsListening(false);

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setText(transcript);
    };

    recognition.onerror = (event) => {
      console.error('Error:', event.error);
      setIsListening(false);
    };

    recognition.start();
  };
  useEffect(() => {
    if (text!=="")
    handleAnswer(text)
  }, [text])

  return (
    <div className="p-4 text-center">
      <Button
        variant="outline"
        onClick={startListening}
        className={"p-8 rounded"}>
        <Mic />
        {" "}
        {isListening ? 'Listening...' : 'Nhấn để nói'}
      </Button>
      <p className="mt-4">Your answer: <strong>{text}</strong></p>
    </div>
  );
};

export default SpeechToText;
